<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="mt-4 ml-4">
        <v-col>
          <span class="text-h5 font-weight-bold" v-text="'Employees'"></span>
          <v-btn class="mx-2 mb-2" fab x-small color="primary" to="/users/create">
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
          <v-btn class="mx-2 mb-2" fab x-small color="primary" to="/users/upload">
            <v-icon dark> mdi-upload </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-text>
              <v-row dense align="center">
                <v-col md="3" sm="6">
                  <v-text-field v-model="search_keyword" label="Search" prepend-inner-icon="mdi-magnify"
                    outlined dense hide-details clearable
                    @keydown.enter="getData" @change="page = 1"></v-text-field>
                </v-col>
                <v-col md="3" sm="6" v-if="allCompanies.length > 0">
                  <v-autocomplete v-model="form.filter_company_id" :items="allCompanies"
                    label="Company" @input="getData" prepend-inner-icon="mdi-domain"
                    outlined dense hide-details clearable></v-autocomplete>
                </v-col>
                <v-col md="3" sm="6">
                  <v-autocomplete ref="designation" v-model="form.designation_id" :items="designations"
                    label="Designation" @input="getData" prepend-inner-icon="mdi-badge-account"
                    outlined dense hide-details clearable></v-autocomplete>
                </v-col>
                <v-col md="3" sm="6">
                  <v-autocomplete ref="supervisor" v-model="form.supervisor_id" :items="supervisors" label="Supervisor"
                    @input="getData" prepend-inner-icon="mdi-account-tie"
                    :disabled="user.roles && user.roles[0] && user.roles[0].name === 'SUPERVISOR'"
                    :clearable="!(user.roles && user.roles[0] && user.roles[0].name === 'SUPERVISOR')"
                    outlined dense hide-details></v-autocomplete>
                </v-col>
              </v-row>
              <v-row dense align="center" class="mt-2 mb-1">
                <v-col md="3" sm="6">
                  <v-autocomplete ref="status" v-model="form.active" :items="statuses" label="Status" @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                    outlined dense hide-details clearable></v-autocomplete>
                </v-col>
                <v-spacer></v-spacer>
                <v-col md="4" sm="12">
                  <v-pagination v-model="page" :length="paginationLength">
                  </v-pagination>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-progress-linear v-if="isLoading" indeterminate color="primary"></v-progress-linear>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-title v-if="users.length != 0">
              <v-spacer></v-spacer>
              <v-btn class="primary mx-4" @click="generateExcel()">
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Role</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Phone</th>
                    <th class="text-left">Supervisor</th>
                    <!-- <th class="text-left">Date Of Joining</th> -->
                    <th class="text-left">Designation</th>
                    <th class="text-left" v-if="allCompanies.length > 0">Company</th>
                    <th class="text-left">Password</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody v-if="users.length != 0">
                  <tr v-for="(user, i) in users" :key="`user${i}`">
                    <td style="min-width: 85px">
                      <v-tooltip bottom v-if="user.active == 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" small dark color="green">
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>User is Active</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="user.active == 0">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" small dark color="red">
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>User is InActive</span>
                      </v-tooltip>
                      &nbsp;
                      {{ i + 1 }}
                    </td>
                    <!-- <td>{{ user.roles && user.roles.length > 0 ? user.roles[0].name : "" }}</td> -->
                    <!-- <td>{{ user.roles[0].name }}</td> -->
                    <td>{{ user.roles[0] ? user.roles[0].name : "" }}</td>
                    <td>{{ user.name || "" }}</td>
                    <td>{{ user.email || "" }}</td>
                    <td>{{ user.phone || "" }}</td>
                    <!-- <td>
                      {{ user.supervisor_id ? user.supervisor?.name : "" }}
                    </td> -->
                    <td>
                      {{ user.supervisor_id ? user.supervisor?.name : "" }}
                    </td>
                    <td>
                      {{ user.designation ? user.designation.code : "" }}
                    </td>
                    <td v-if="allCompanies.length > 0">
                      <v-chip small color="blue-grey lighten-4" text-color="blue-grey darken-3" v-if="user.companies && user.companies.length > 0">
                        {{ user.companies[0].name }}
                      </v-chip>
                      <span v-else>-</span>
                    </td>

                    <td>
                      <div class="d-flex align-center" style="min-width: 140px">
                        <span v-if="visiblePasswordId === user.id" class="mr-1">{{ user.soft_password || 'N/A' }}</span>
                        <span v-else class="mr-1">********</span>
                        <v-btn icon x-small @click="togglePasswordVisibility(user.id)" class="mr-1">
                          <v-icon small>{{ visiblePasswordId === user.id ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                        </v-btn>
                        <v-btn icon x-small color="primary" @click="openChangePasswordDialog(user)">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                    </td>

                    <td class="text-right">
                      <v-btn class="mx-2" fab x-small color="primary" :to="`/users/${user.id}`">
                        <v-icon dark> mdi-pencil </v-icon>
                      </v-btn>
                      <!-- <v-btn
                        class="mx-2"
                        color="error"
                        fab
                        x-small
                        @click="Delete_this(user.id)"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn> -->
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="12" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="showPasswordDialog" max-width="420" persistent>
      <v-card>
        <v-card-title>
          <v-icon color="primary" class="mr-2">mdi-lock-reset</v-icon>
          Change Password
        </v-card-title>
        <v-card-subtitle class="mt-1" v-if="passwordUser">
          {{ passwordUser.name }}
        </v-card-subtitle>
        <v-card-text>
          <v-text-field
            v-model="newPassword"
            outlined
            label="New Password"
            prepend-inner-icon="mdi-lock"
            :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showNewPassword ? 'text' : 'password'"
            @click:append="showNewPassword = !showNewPassword"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeChangePasswordDialog">Cancel</v-btn>
          <v-btn color="primary" :loading="isPasswordSaving" @click="savePassword">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "usersPage",
  data() {
    return {
      form: {
        active: 1,
        supervisor_id: "",
        role_id: "",
        designation_id: "",
        filter_company_id: "",
      },
      allCompanies: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      search_keyword: "",
      users: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      roles: [
        {
          id: 0,
          text: "Select Role",
          value: "",
        },
      ],
      supervisors: [
        {
          id: 0,
          text: "Select Supervisors",
          value: "",
        },
      ],
      designations: [
        {
          id: 0,
          text: "Select Designation",
          value: "",
        },
      ],
      visiblePasswordId: null,
      showPasswordDialog: false,
      passwordUser: null,
      newPassword: "",
      showNewPassword: false,
      isPasswordSaving: false,
      isLoading: false,
      isExcelloading: false,
      ExportUsers: [],
      Export_users: [],
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        Email: "email",
        Phone: "phone",
        Supervisor: "supervisor",
        "Is Active": "status",
      },
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    if (this.user.roles[0].name == "SUPERVISOR") {
      this.form.supervisor_id = this.user.id;
    }
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get(`users/masters`);
      masters = masters.data;
      // Roles
      masters.roles.forEach((role) => {
        this.roles.push({
          id: role.id,
          text: role.name,
          value: role.id,
        });
      });
      // Supervisors
      masters.supervisors.forEach((supervisor) => {
        if (this.user.roles[0].name == "SUPERVISOR") {
          if (supervisor.id == this.user.id) {
            this.supervisors.push({
              id: supervisor.id,
              text: supervisor.name,
              value: supervisor.id,
            });
          }
        } else {
          this.supervisors.push({
            id: supervisor.id,
            text: supervisor.name,
            value: supervisor.id,
          });
        }
      });
      //Designation
      masters.designations.forEach((designation) => {
        this.designations.push({
          id: designation.id,
          text: designation.description,
          value: designation.id,
        });
      });
      // Companies (only for main company)
      if (masters.companies && masters.companies.length > 0) {
        this.allCompanies = [
          { text: "All Companies", value: "all" },
        ];
        masters.companies.forEach((company) => {
          this.allCompanies.push({
            text: company.name,
            value: company.id,
          });
        });
      }
    },
    async getData() {
      console.log(this.form.supervisor_id);
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      this.active = this.active ? this.active : "";
      this.role_id = this.role_id ? this.role_id : "";
      let users = [];
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.form.active +
        "&roleId=" +
        this.form.role_id +
        "&supervisorId=" +
        this.form.supervisor_id +
        "&designationId=" +
        this.form.designation_id +
        "&filter_company_id=" +
        (this.form.filter_company_id || "") +
        "&roleId=10";
      users = await axios.get(`users?${query}`);
      this.users = users.data.data;
      // this.users = users.data.data.filter(user => {
      //   return user.roles[0].name === 'USER';
      // });
      // console.log(this.users);
      this.count = users.data.count;
      this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
      this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      this.isLoading = false;
    },
    //  async Delete_this(id) {
    //   let check = confirm("Are you sure you want to delete the data");
    //   if (check) {
    //     try {
    //       this.isLoading = true;
    //       await axios.delete(`users/${id}`);
    //       this.isLoading = false;
    //       this.getData();
    //     } catch (e) {
    //       this.isLoading = false;
    //     }
    //   }
    // },

    async addToExcelData() {
      this.isExcelLoading = true;
      this.title = "Company Lists";
      let Export_users = [];
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.form.active +
        "&roleId=" +
        this.form.role_id;
      Export_users = await axios.get(`users?${query}`);
      this.Export_users = Export_users.data.data;

      this.Export_users.forEach((user) => {
        this.ExportUsers.push({
          sr_no: user.sr_no,
          name: user.name ? user.name.toUpperCase() : "",
          email: user.email ? user.email.toUpperCase() : "",
          phone: user.phone ? user.phone : "",

          supervisor: user.supervisor_id
            ? user.supervisor.name.toUpperCase()
            : "",
          status: user.active == 1 ? "YES" : "NO",
        });
      });
      this.isExcelLoading = false;
    },
    togglePasswordVisibility(userId) {
      this.visiblePasswordId = this.visiblePasswordId === userId ? null : userId;
    },
    openChangePasswordDialog(user) {
      this.passwordUser = user;
      this.newPassword = "";
      this.showNewPassword = false;
      this.showPasswordDialog = true;
    },
    closeChangePasswordDialog() {
      this.showPasswordDialog = false;
      this.passwordUser = null;
      this.newPassword = "";
    },
    async savePassword() {
      if (!this.newPassword) return;
      try {
        this.isPasswordSaving = true;
        await axios.patch(`/users/${this.passwordUser.id}`, {
          name: this.passwordUser.name,
          email: this.passwordUser.email,
          soft_password: this.newPassword,
        });
        this.passwordUser.soft_password = this.newPassword;
        this.closeChangePasswordDialog();
        this.isPasswordSaving = false;
      } catch (e) {
        this.isPasswordSaving = false;
      }
    },
    async generateExcel() {
      this.isExcelloading = true;
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      this.active = this.active ? this.active : "";
      this.role_id = this.role_id ? this.role_id : "";
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.form.active +
        "&roleId=" +
        this.form.role_id +
        "&supervisorId=" +
        this.form.supervisor_id +
        "&designationId=" +
        this.form.designation_id +
        "&filter_company_id=" +
        (this.form.filter_company_id || "");
      try {
        let response = await axios.get(`usersExports?${query}`);
        if (response && response.data && response.data.data) {
          window.open(`${response.data.data}`, "_blank");
        } else {
          console.error("Invalid response data:", response.data);
        }
      } catch (error) {
        console.error("Error fetching Excel data:", error);
      }
      this.getData();
      this.isExcelloading = false;
      console.log('a')
    },
  },
};
</script>
